var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"target":_vm.target,"triggers":"hover","placement":"top"}},[_c('div',{staticClass:"font-semibold text-start mb-1"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-start"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }